import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { listBranch } from '../actions/branchActions';

export default function Branch() {
    const dispatch = useDispatch();

    const branchList = useSelector(state => state.branchList);
    const { branches, loading, error } = branchList

    useEffect(() => {
        if (branches == undefined) {
            dispatch(listBranch())
        }else if(branches.length == 0){
            dispatch(listBranch())
        }
    }, [dispatch, branches])
    return (
        <>
        {
            loading ? (
                <option value="0">Loading...</option>
            ) : (
                branches ? (
                    branches.map(countf => (
                        <option key={countf.Id} value={countf.Id}>{countf.Branch}</option>
                    ))
                ) : (
                    <option value="0">{error}</option>
                )
            )
        }
        </>

  )
}

